exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rotator-4-wrapper[data-v-a6e778d6]{width:auto;max-width:410px;padding-bottom:10px}.rg-rotator-4-content[data-v-a6e778d6]{min-width:350px}@media screen and (max-width:700px){.rg-rotator-4-content[data-v-a6e778d6]{min-width:auto}}", ""]);

// exports
